import Swiper from 'swiper';

const attentionPage = $('#attention').length;
const attentionEggPage = $('#attentionEggSlider');
const attention = $('#attentionSlider');

export function attentionFunc() {
  if (attentionPage) {
    if (attention) {
      let attentionSwiper, attentionOptions;
      attentionSwiper = undefined;
      attentionOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 2.5,
        navigation: {
          nextEl: '.attentionNext',
          prevEl: '.attentionPrev',
        },
        breakpoints: {
          751: {
            spaceBetween: 60
          },
          320: {
            spaceBetween: 20
          }
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        }
      };

      function initAttentionSwiper() {
        attentionSwiper = new Swiper('#attentionSlider', attentionOptions);
      }
      initAttentionSwiper();
    }
    if (attentionEggPage) {
      let attentionEggSwiper, attentionEggOptions;
      attentionEggSwiper = undefined;
      attentionEggOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 2.5,
        navigation: {
          nextEl: '.attentionEggNext',
          prevEl: '.attentionEggPrev',
        },
        breakpoints: {
          751: {
            spaceBetween: 60
          },
          320: {
            spaceBetween: 20
          }
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        }
      };

      function initAttentionEggSwiper() {
        attentionEggSwiper = new Swiper('#attentionEggSlider', attentionEggOptions);
      }
      initAttentionEggSwiper();
    }
  }
}
